export default __webpack_public_path__ + "static/biotech-c5ce565ba6e84c952710fa9f877a8802.jpg";